import Bugsnag from '@bugsnag/js';

window.Bugsnag = Bugsnag;
Bugsnag.start({
  apiKey: window.gon.bugsnag_api_key,
  onError: event => {
    // Note: The ResizeObserver errors occur from the Pager component in mode-react.
    // The kore-frontend team has advised they are safe to ignore.
    const errorsToIgnore = [
      'ResizeObserver loop completed with undelivered notifications.',
      'ResizeObserver loop limit exceeded',
    ];

    if (errorsToIgnore.includes(event.errors[0]?.errorMessage)) {
      return false;
    }

    return true;
  },
  metadata: {
    client: {
      businessLine: window.gon.client_business_line,
      clientId: window.gon.client_id,
      locale: window.gon.locale,
      region: window.gon.client_region,
      visitorId: window.gon.visitor_id,
    },
  },
});
